import classNames from 'classnames';
import { generatePath } from 'react-router-dom';

import { LocalizedLink } from '@ui/LocalizedLink';
import { Link } from '@ui/Link';
import * as path from '@legacyUrls';
import { virtualCatalog } from '@urls';

import s from './VirtualCatalogLinkedCatalogs.sss';

type LinkedCatalog = {
  id: number
  label: string
  slug: string
  namespace: string
};

type LinkedVirtualCatalog = {
  id: number
  label: string
  slug: string
};

export type LinkedCatalogLink = LinkedCatalog | LinkedVirtualCatalog;

type Props = {
  linkedCatalogs: LinkedCatalogLink[]
  className?: string
};

export const VirtualCatalogLinkedCatalogs: React.FC<Props> = ({
  linkedCatalogs,
  className,
}) => (
  <div className={classNames(s.root, className)}>
    {/* catalog and virtualCatalog, workaround to prevent `/` replace on `%2F` */}
    {linkedCatalogs.map(
      (catalog) => (
        'namespace' in catalog
          ? (
            <LocalizedLink
              key={catalog.id}
              className={s.link}
              theme="black"
              href={
                catalog.namespace === catalog.slug
                  ? generatePath(path.baseCatalog, { namespace: catalog.namespace })
                  : decodeURIComponent(
                    generatePath(
                      path.catalog,
                      { namespace: catalog.namespace, slug: catalog.slug },
                    ),
                  )
              }
            >
              {catalog.label}
            </LocalizedLink>
          )
          : (
            <Link
              key={catalog.id}
              className={s.link}
              theme="black"
              to={decodeURIComponent(
                generatePath(
                  virtualCatalog,
                  { virtualCatalogSlug: catalog.slug },
                ),
              )}
            >
              {catalog.label}
            </Link>
          )
      ),
    )}
  </div>
);
